module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/greenery-20836df4485e0d955a06ddbca4803ac5.jpg";